export default __webpack_public_path__ + "static/media/drone-icon.b8085fbc.png";